import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Flag from "../../assets/static/flag_bt.png";
import "./Top.sass";

export const Top = () => {
  const [link, setLink] = useState({});

  useEffect(() => {
    const LinkSession = window.sessionStorage.getItem("menuV2");

    if (!LinkSession) {
      const LLDDLink = fetch(`https://legendofeldorado.com/2018/api/enlace-personalizado/1`);
      const CaribeLink = fetch(`https://legendofeldorado.com/2018/api/enlace-personalizado/2`);
      const seriesManizales = fetch(`https://legendofeldorado.com/series-admin-temporal/api/enlace-personalizado/1`);

      Promise.all([LLDDLink, CaribeLink, seriesManizales]).then(async ([lldd, caribe, seriesManizales]) => {
        const Links = {
          lldd: await lldd.json(),
          caribe: await caribe.json(),
          seriesManizales: await seriesManizales.json(),
        };

        setLink(Links);
        try {
          window.sessionStorage.setItem("menuV2", JSON.stringify(Links));
        } catch (error) {
          return console.log(error);
        }
      });
    }
    setLink(JSON.parse(LinkSession));
  }, []);

  return (
    <div className="row">
      <div className="col-xs-12 Top">
        <div className="hidden-lg Top-burger">
          <a id="menu_mobil" href="#my-menu">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="32px"
              height="25px"
              viewBox="0 0 32 32"
            >
              <rect x="1.599" y="1.731" fill="#000" width="28.803" height="4" />
              <rect x="1.599" y="13" fill="#000" width="28.803" height="4" />
              <rect x="1.599" y="24.268" fill="#000" width="28.803" height="4" />
            </svg>
          </a>
        </div>
        <div>
          <a href="/">
            <span className="Top-logo-lldd"></span>
          </a>
        </div>
        <div className="Top-main-menu hidden-xs hidden-sm hidden-md">
          <nav>
            <ul className="Top-menu">
              <li className="Top-lldd">
                <a href="https://legendofeldorado.com/">
                  LA LEYENDA <br /> DEL DORADO
                </a>
                <div className="Top-lldd-container">
                  <div className="Top-lldd-container-wrap">
                    <b>LA LEYENDA DEL DORADO - CARRERA MTB DE 5 ETAPAS</b>
                    <div className="Top-lldd-grid">
                      <div className="Top-lldd-itema">
                        <a className="Top-lldd-link --red" href={link?.lldd?.url_es}>
                          {link?.lldd?.title_es}
                        </a>
                      </div>
                      <div className="Top-lldd-itemb">
                        <a className="Top-lldd-link" href="/contact-us">
                          CONTÁCTENOS
                        </a>
                      </div>
                      <div className="Top-lldd-itemc">
                        <p className="text-yellow">INICIO</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="/">- La Leyenda Resumen</a>
                          </li>
                          <li>
                            <a href="/home/packages">- Paquetes y Ascensos</a>
                          </li>
                          <li>
                            <a href="/home/prices">- Precios</a>
                          </li>
                          <li>
                            <a href="/home/payment">- Plan de pagos</a>
                          </li>
                          <li>
                            <a href="/home/categories">- Categorías</a>
                          </li>
                          <li>
                            <a href="/home/testimonials">- Testimonios</a>
                          </li>
                          <li>
                            <a href="/home/no-excuses">- No hay excusas</a>
                          </li>
                          <li>
                            <a href="/home/news">- Últimas noticias</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-lldd-itemd">
                        <p className="text-yellow">ACERCA DE LA CARRERA</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="/about-us/race_overview">- Descripción de la carrera</a>
                          </li>
                          <li>
                            <a href="/about-us/packages-upgrades">- Paquetes y Ascensos</a>
                          </li>
                          <li>
                            <a href="/about-us/categories_and_prizes">- Categorías & Premios</a>
                          </li>
                          <li>
                            <a href="/about-us/charity-entries">- Registros de fundaciones</a>
                          </li>
                          <li>
                            <a href="/about-us/payment-options">- Opciones de pago</a>
                          </li>
                          <li>
                            <a href="/about-us/rules">- Reglamento</a>
                          </li>
                          <li>
                            <a href="/about-us/social-responsibility">- Responsabilidad social</a>
                          </li>
                          <li>
                            <a href="/about-us/safety_and_security">- Seguridad</a>
                          </li>
                          <li>
                            <a href="/about-us/travel">- Viajar</a>
                          </li>
                          <li>
                            <a href="/about-us/tours">- Tours</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-lldd-iteme">
                        <p className="text-yellow">RUTA</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="/route/2016/summary">- 2016 Guaduas a Retiro</a>
                          </li>
                          <li>
                            <a href="/route/2017/summary">- 2017 Caldas</a>
                          </li>
                          <li>
                            <a href="/route/2018/summary">- 2018 Caldas</a>
                          </li>
                          <li>
                            <a href="/route/2019/summary">- 2019 Caldas</a>
                          </li>
                          <li>
                            <a href="/route/2022/summary">- 2022 Valle del Cauca</a>
                          </li>
                          <li>
                            <a href="/route/2023/summary">- 2023 Caldas</a>
                          </li>
                          <li>
                            <a href="/route/2024">- 2024 Información</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-lldd-itemf">
                        <p className="text-yellow">CORREDORES</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="/racers/what_to_pack">- Qué empacar</a>
                          </li>
                          <li>
                            <a href="/racers/daily_schecdule">- Horario diario</a>
                          </li>
                          <li>
                            <a href="/racers/tips-and-tricks">- Consejos y trucos</a>
                          </li>
                          <li>
                            <a href="/racers/jaguares">- Jaguares</a>
                          </li>
                          <li>
                            <a href="/racers/training">- Entrenamiento</a>
                          </li>
                          <li>
                            <a href="/results">- Resultados</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-lldd-itemg">
                        <p className="text-yellow">PATROCINADORES Y COLABORADORES</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="/sponsors-and-partner">- Patrocinadores y colaboradores</a>
                          </li>
                          <li>
                            <a href="/sponsors-and-partner/become-a-sponsor">- Conviértete en patrocinador</a>
                          </li>
                          <li>
                            <a href="/sponsors-and-partner/expo-information">- Información de la expo</a>
                          </li>
                        </ul>
                        <p className="mt-4 d-block text-yellow">NOTICIAS & MEDIOS</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="/latest-news">- Últimas noticias</a>
                          </li>
                          <li>
                            <a href="/gallery">- Galería</a>
                          </li>
                          <li>
                            <a href="/videos/2021">- Videos</a>
                          </li>
                          <li>
                            <a href="/news-and-media/press">- Prensa</a>
                          </li>
                          <li>
                            <a href="/news-and-media/newsletters">- Boletín de noticias</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-lldd-itemh">
                        <p className="text-yellow">PREGUNTAS FRECUENTES</p>
                        <ul className="Top-lldd-list">
                          <li>
                            <a href="/faqs/race-info">- Info de la carrera</a>
                          </li>
                          <li>
                            <a href="/faqs/logistics">- Logistica</a>
                          </li>
                          <li>
                            <a href="/faqs/registration">- Registro</a>
                          </li>
                          <li>
                            <a href="/faqs/services">- Servicios</a>
                          </li>
                          <li>
                            <a href="/faqs/accommodation">- Alojamiento</a>
                          </li>
                          <li>
                            <a href="/faqs/equipment">- Equipamento</a>
                          </li>
                          <li>
                            <a href="/faqs/insurance">- Seguro</a>
                          </li>
                          <li>
                            <a href="/faqs/cancelation-refunds">- Cancelación y reembolsos</a>
                          </li>
                          <li>
                            <a href="/faqs/supporters">- Acompañantes</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li className="Top-aruba">
                <a href="https://www.aruba-la-leyenda.com/">
                  LA LEYENDA <br /> ARUBA
                </a>
              </li>
              <li className="Top-caribe">
                <Link to="/">
                  LA LEYENDA <br /> PUNTA CANA
                </Link>
                <div className="Top-caribe-container">
                  <div className="Top-caribe-container-wrap">
                    <b> LA LEYENDA PUNTA CANA - CARRERA MTB DE 5 ETAPAS - REPÚBLICA DOMINICANA</b>
                    <div className="Top-caribe-grid">
                      <div className="Top-caribe-itema">
                        <a className="Top-caribe-link" href={link?.caribe?.url_es}>
                          {link?.caribe?.title_es}
                        </a>
                      </div>
                      <div className="Top-caribe-itemb">
                        <Link className="Top-caribe-link" to="/contactanos">
                          CONTÁCTENOS
                        </Link>
                      </div>
                      <div className="Top-caribe-itemc">
                        <p>INICIO</p>
                        <ul className="Top-caribe-list">
                          <li>
                            <Link to="/">- Leyenda Caribe Resumen</Link>
                          </li>
                          <li>
                            <Link to="/paquetes-y-ascensos">- Paquetes y Ascensos</Link>
                          </li>
                          <li>
                            <Link to="/precios">- Precios</Link>
                          </li>
                          <li>
                            <Link to="/categorias-y-premiacion">- Categorías y Premiación</Link>
                          </li>
                          <li>
                            <Link to="/rutas-y-reglamentacion/resumen">- Rutas y Reglamentación</Link>
                          </li>
                          <li>
                            <Link to="/2023/resultados">- Resultados</Link>
                          </li>
                          <li>
                            <Link to="/patrocinio">- Patrocinio</Link>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-caribe-itemd">
                        <p>RUTAS</p>
                        <ul className="Top-caribe-list">
                          <li>
                            <a href="/caribe/rutas/2023-punta-cana/resumen">- 2023 Punta Cana</a>
                          </li>
                          <li>
                            <a href="/caribe/rutas/2024-punta-cana/resumen">- 2024 Punta Cana</a>
                          </li>
                          <li>
                            <a href="/caribe/rutas/2025-punta-cana/informacion">- 2025 Información</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-caribe-iteme">
                        <p>GALERÍA</p>
                        <ul className="Top-caribe-list">
                          <li>
                            <Link to="/galeria/2023/punta-cana/registros">- 2023 Punta Cana</Link>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-caribe-itemf">
                        <p>VIDEOS</p>
                        <ul className="Top-caribe-list">
                          <li>
                            <Link to="/videos/2023-punta-cana">- 2023 Punta Cana</Link>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-caribe-itemg"></div>
                    </div>
                  </div>
                </div>
              </li>
              <li className="Top-series">
                <a href="https://legendofeldorado.com/series">
                  LA LEYENDA <br /> SERIES
                </a>
                <div className="Top-series-container">
                  <div className="Top-series-container-wrap">
                    <b>LA LEYENDA SERIES - EVENTOS MTB DE 1 DÍA</b>
                    <div className="Top-series-grid">
                      <div className="Top-series-itema">
                        <a className="Top-series-link" href="https://legendofeldorado.com/series">
                          INICIO
                        </a>
                      </div>
                      <div className="Top-series-itemb">
                        <a className="Top-series-link" href="https://legendofeldorado.com/series/contactenos">
                          CONTACTANOS
                        </a>
                      </div>
                      <div className="Top-series-itemc">
                        <p>ZIPAQUIRA 2025</p>
                        <ul className="Top-series-list">
                          <li>
                            <a href={link?.seriesManizales?.url_es} target="blank">
                              - {link?.seriesManizales?.title_es}
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/series/zipaquira/acerca-de-la-carrera">
                              - Series Zipaquirá resumen
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/series/zipaquira/precios-que-incluye">
                              - Precios y qué incluye
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/series/zipaquira/mtb_carrera">- Rutas</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/series/zipaquira/categorias">- Categorías</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/series/zipaquira/premiacion-y-reglamento">
                              - Premiación y reglamento
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/series/zipaquira/patrocinio-expo">- Patrocinio y expo</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-series-itemd">
                        <p>MANIZALES 2024</p>
                        <ul className="Top-series-list">
                          <li>
                            <a href="https://legendofeldorado.com/series/manizales/acerca-de-la-carrera">
                              - Series Manizales resumen
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/series/manizales/categorias">- Categorías y rutas</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/series/manizales/galeria">- Galería</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/series/manizales/resultados">- Resultados</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-series-iteme">
                        <p>CALDAS 2022</p>
                        <ul className="Top-series-list">
                          {/* <li><a href="https://legendofeldorado.com/series/caldas/registro">- REGISTRO</a></li> */}
                          <li>
                            <a href="https://legendofeldorado.com/series/caldas/acerca-de-la-carrera">
                              - Series Caldas resumen
                            </a>
                          </li>
                          {/* <li>
                            <a href="https://legendofeldorado.com/series/caldas/precios-que-incluye">
                              - Precios y qué incluye
                            </a>
                          </li> */}
                          <li>
                            <a href="https://legendofeldorado.com/series/caldas/categorias-y-rutas">- Categorías y rutas</a>
                          </li>
                          {/* <li>
                            <a href="https://legendofeldorado.com/series/caldas/premiacion-y-reglamento">
                              - Premiación y reglamento
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/series/caldas/patrocinio-expo">
                              - Patrocinio y expo
                            </a>
                          </li> */}
                          <li>
                            <a href="https://legendofeldorado.com/series/caldas/galeria">- Galería</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/series/caldas/resultados">- Resultados</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-series-itemf">
                        <p>CALI 2021</p>
                        <ul className="Top-series-list">
                          {/* <li><a href="https://legendofeldorado.com/series/cali/registro">- REGISTRO</a></li> */}
                          <li>
                            <a href="https://legendofeldorado.com/series/cali/acerca-de-la-carrera">- Series Cali resumen</a>
                          </li>
                          {/* <li>
                            <a href="https://legendofeldorado.com/series/cali/precios-que-incluye">
                              - Precios y qué incluye
                            </a>
                          </li> */}
                          <li>
                            <a href="https://legendofeldorado.com/series/cali/categorias-y-rutas">- Categorías y rutas</a>
                          </li>
                          {/* <li>
                            <a href="https://legendofeldorado.com/series/cali/premiacion-y-reglamento">
                              - Premiación y reglamento
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/series/cali/patrocinio-expo">
                              - Patrocinio y expo
                            </a>
                          </li> */}
                          <li>
                            <a href="https://legendofeldorado.com/series/cali/galeria">- Galería</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/series/cali/resultados">- Resultados</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-series-itemg"></div>
                    </div>
                  </div>
                </div>
              </li>
              <li className="Top-adventures">
                <a href="https://legendofeldorado.com/adventures/">
                  LA LEYENDA <br /> ADVENTURES
                </a>
                <div className="Top-adventures-container">
                  <div className="Top-adventures-container-wrap">
                    <b>LA LEYENDA ADVENTURES - EXPERIENCIAS EN CICLISMO DE LUJO, ORGANIZADAS POR EXPERTOS</b>
                    <div className="Top-adventures-grid">
                      <div className="Top-adventures-itema">
                        <a className="Top-adventures-link" href="https://legendofeldorado.com/adventures">
                          INICIO
                        </a>
                      </div>
                      <div className="Top-adventures-itemb">
                        <a className="Top-adventures-link" href="https://legendofeldorado.com/adventures/contact-us">
                          CONTÁCTANOS
                        </a>
                      </div>
                      <div className="Top-adventures-itemc">
                        <a className="Top-adventures-link" href="https://legendofeldorado.com/adventures/custom-tour">
                          AVENTURA PERSONALIZADO
                        </a>
                      </div>
                      <div className="Top-adventures-itemd"></div>
                      <div className="Top-adventures-iteme">
                        <p>
                          AVENTURA DEL CAFÉ <span>MTB - Pereira a Pereira</span>
                        </p>
                        <ul className="Top-adventures-list --coffee">
                          <li>
                            <a href="https://legendofeldorado.com/adventures/coffee-mtb/tour-overview">- Acerca del tour</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/coffee-mtb/itinerary/start">- Itinerario</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/coffee-mtb/package-and-price">
                              - Paquetes y precio
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/coffee-mtb/upgrades-and-prices">
                              - Ascensos y precios
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/coffee-mtb/hotels">- Hoteles</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/coffee-mtb/travel-details">
                              - Detalles del viaje
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/coffee-mtb/important-info">
                              - Información importante
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/booknow/coffee-mtb">- RESERVAR AHORA</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-adventures-itemf">
                        <p>
                          AVENTURA ANTIOQUIA <span>MTB - Medellin a Medellin</span>
                        </p>
                        <ul className="Top-adventures-list --antioquia">
                          <li>
                            <a href="https://legendofeldorado.com/adventures/antioquia-mtb/tour-overview">
                              - Acerca del tour
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/antioquia-mtb/itinerary/start">- Itinerario</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/antioquia-mtb/package-and-price">
                              - Paquetes y precio
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/antioquia-mtb/upgrades-and-prices">
                              - Ascensos y precios
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/antioquia-mtb/hotels">- Hoteles</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/antioquia-mtb/travel-details">
                              - Detalles del viaje
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/antioquia-mtb/important-info">
                              - Información importante
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/booknow/antioquia-mtb">- RESERVAR AHORA</a>
                          </li>
                        </ul>
                      </div>
                      <div className="Top-adventures-itemg">
                        <p>
                          AVENTURA VOLCÁN <span>MTB - Bogotá a Pereira</span>
                        </p>
                        <ul className="Top-adventures-list --volcano">
                          <li>
                            <a href="https://legendofeldorado.com/adventures/volcano-mtb/tour-overview">- Acerca del tour</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/volcano-mtb/itinerary/start">- Itinerario</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/volcano-mtb/package-and-price">
                              - Paquetes y precio
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/volcano-mtb/upgrades-and-prices">
                              - Ascensos y precios
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/volcano-mtb/hotels">- Hoteles</a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/volcano-mtb/travel-details">
                              - Detalles del viaje
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/volcano-mtb/important-info">
                              - Información importante
                            </a>
                          </li>
                          <li>
                            <a href="https://legendofeldorado.com/adventures/booknow/volcano-mtb">- RESERVAR AHORA</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </nav>
        </div>
        <div className="Top-redes">
          <a href="https://legendofeldorado.com/caribe/en">
            <img className="img-responsive" src={Flag} alt="Idioma Ingles" />
          </a>
        </div>
      </div>
    </div>
  );
};
